import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

const { Types, Creators } = createActions({
	hideMessage: null,
	showAuthLoader: null,
	setInitUrl: ['initUrl'],
	onHideLoader: null,
	hideAuthLoader: null,
	showAuthMessage: ['message'],
	userSignInGoogle: ['user'],
	userSignInGoogleSuccess: ['user'],
	userSignIn: ['user'],
	userSignInSuccess: ['user'],
	userSignOut: null,
	userSignOutSuccess: null,
	userSignUp: ['user'],
	userSignUpSuccess: ['user'],
	getUserInfo: ['user']
});

export const INITIAL_STATE = Immutable.from({
	loader: false,
	alertMessage: '',
	showMessage: false,
	initURL: '',
	authUser: localStorage.getItem('user_id'),
});

export const AuthTypes = Types;
export default Creators;

const showAuthMessage = (state, { message }) => state.merge({
	alertMessage: message,
	showMessage: true,
	loader: false
});

const signoutUserSuccess = state => state.merge({
	initURL: '/',
	loader: false
});

const hideMessage = state => state.merge({
	alertMessage: '',
	showMessage: false,
	loader: false,
});

const showAuthLoader = state => state.merge({
	loader: true,
});

const hideAuthLoader = state => state.merge({
	loader: false,
});

const setInitUrl = (state, { initURL }) => state.merge({
	initURL: initURL ? initURL : ''
});
export const reducer = createReducer(INITIAL_STATE, {
	[Types.HIDE_MESSAGE]: hideMessage,
	[Types.SET_INIT_URL]: setInitUrl,
	[Types.HIDE_AUTH_LOADER]: hideAuthLoader,
	[Types.SHOW_AUTH_LOADER]: showAuthLoader,
	[Types.SHOW_AUTH_MESSAGE]: showAuthMessage,
	[Types.USER_SIGN_IN_GOOGLE]: showAuthLoader,
	[Types.USER_SIGN_IN_GOOGLE_SUCCESS]: hideAuthLoader,
	[Types.USER_SIGN_IN]: showAuthLoader,
	[Types.USER_SIGN_IN_SUCCESS]: hideAuthLoader,
	[Types.USER_SIGN_OUT]: showAuthLoader,
	[Types.USER_SIGN_OUT_SUCCESS]: signoutUserSuccess,
	[Types.USER_SIGN_UP]: showAuthLoader,
	[Types.USER_SIGN_UP_SUCCESS]: hideAuthLoader,
});